interface SecurityTrustStripProps {
  privacyLink?: string;
}

export default function SecurityTrustStrip({ 
  privacyLink = "/legal#privacy" 
}: SecurityTrustStripProps) {
  return (
    <div className="bg-slate-50 border-b border-slate-200 py-3">
      <div className="container-main">
        <div className="flex flex-col items-center gap-2 text-sm sm:flex-row sm:justify-center">
          <svg 
            className="w-4 h-4 text-emerald-700 shrink-0" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
            aria-hidden="true"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" 
            />
          </svg>
          <span className="text-slate-700">
            Your documents are stored securely, used only to generate your forms, and are not shared.
          </span>
          <a 
            href={privacyLink}
            className="text-blue-700 hover:text-blue-800 hover:underline whitespace-nowrap"
          >
            Learn how we handle your data
          </a>
        </div>
      </div>
    </div>
  );
}
